/*
 * yt-analytics — first-party GA4 event layer (2026-07-12).
 *
 * WHY THIS EXISTS: the Google & YouTube app's pixel covers the standard
 * ecommerce events (page_view, view_item, add_to_cart, begin_checkout,
 * purchase) from inside Shopify's pixel sandbox. It cannot see custom
 * storefront interactions (builder filters, ingredient picks, chat
 * steps). This layer fires those as GA4 custom events on the SAME
 * property (G-GKSXHS26RB) via a page-level gtag.
 *
 * CONSENT (2026-08-24, Cookiebot removed): the gtag.js loader in
 * snippets/yt-head.liquid now runs unconditionally under Google
 * Consent Mode v2 — defaults all-denied, then yt-head's bridge grants
 * categories from Shopify.customerPrivacy when the NATIVE Shopify
 * cookie banner collects consent. Pre-consent, gtag sends only
 * cookieless pings; no analytics cookies are written until granted.
 *
 * NO double page_view: `send_page_view: false` — the Shopify pixel
 * owns page views.
 *
 * USAGE
 *   JS:      window.ytTrack('byo_filter_selected', { filter: 'Most popular' });
 *   Markup:  <button data-yt-track="cta_clicked"
 *                    data-yt-track-params='{"label":"BUILD MY BLEND","location":"hero"}'>
 *            (click is captured by the delegated listener below)
 *
 * RULES: snake_case event names, ≤40 chars; param values are strings/
 * numbers, never personal data (no emails, no free-text the customer
 * typed about themselves).
 */
(function () {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  // Configure our page-level tag exactly once. The loader script in
  // yt-head.liquid may still be consent-blocked — these commands queue
  // in dataLayer until it runs.
  if (!window.__ytGtagConfigured) {
    window.__ytGtagConfigured = true;
    // Founder debug switch: append ?ga_debug=1 to any URL (persists in
    // sessionStorage for the visit) to route THIS device's events into
    // GA4 DebugView without a browser extension. Real visitors are
    // unaffected. Clear with ?ga_debug=0.
    var cfg = { send_page_view: false };
    try {
      var qs = new URLSearchParams(location.search);
      if (qs.get('ga_debug') === '1') sessionStorage.setItem('yt_ga_debug', '1');
      if (qs.get('ga_debug') === '0') sessionStorage.removeItem('yt_ga_debug');
      if (sessionStorage.getItem('yt_ga_debug') === '1') cfg.debug_mode = true;
    } catch (e) { /* private mode — no debug, no harm */ }
    gtag('js', new Date());
    gtag('config', 'G-GKSXHS26RB', cfg);
  }

  window.ytTrack = function (eventName, params) {
    if (!eventName) return;
    try {
      gtag('event', String(eventName).slice(0, 40), params || {});
    } catch (e) { /* analytics must never break the page */ }
  };

  // Native <details> open tracking (FAQ accordions). `toggle` fires on
  // open AND close; gate on .open so we only log opens. Capture phase so
  // it works even though toggle doesn't bubble.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    if (!d.classList.contains('yt-faq__item')) return;
    var q = d.querySelector('.yt-faq__question-text');
    window.ytTrack('faq_opened', { label: (q ? q.textContent : '').trim().slice(0, 80), page: location.pathname });
  }, true);

  // Declarative click tracking: data-yt-track + optional JSON params.
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-yt-track]');
    if (!el) return;
    var params = {};
    var raw = el.getAttribute('data-yt-track-params');
    if (raw) { try { params = JSON.parse(raw); } catch (err) { params = {}; } }
    if (!params.label) {
      params.label = (el.getAttribute('aria-label') || el.textContent || '').trim().slice(0, 60);
    }
    params.page = location.pathname;
    window.ytTrack(el.getAttribute('data-yt-track'), params);
  }, { capture: true, passive: true });
})();
